export class ApplicationSettingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSystemSettings() {
    return this.#http.get('/ApplicationSetting');
  }

  async createSystemSetting(body) {
    return this.#http.post('/ApplicationSetting', body);
  }

  async editSystemSetting({ applicationSettingId, ...body }) {
    return this.#http.put(`/ApplicationSetting/${applicationSettingId}`, body);
  }

  async deleteSystemSetting({ applicationSettingId }) {
    return this.#http.delete(`/ApplicationSetting/${applicationSettingId}`);
  }
}
